import React from "react";
import { Row, Col } from "react-bootstrap";
import { getOriginLabel } from "../assets/functions.js";

const EmptyValue = () => <span className="opacity-50">(Não preenchido)</span>;

const isBlank = (value) =>
  value === undefined || value === null || value === "";

const formatDateValue = ({ formattedValue, rawValue, convertDateToDisplay }) => {
  if (!isBlank(formattedValue)) return formattedValue;

  if (!isBlank(rawValue) && typeof convertDateToDisplay === "function") {
    const converted = convertDateToDisplay(rawValue);
    if (!isBlank(converted)) return converted;
  }

  return null;
};

const InfoField = ({ label, value, mono = false, defaultValue = <EmptyValue /> }) => (
  <Col md={6} className="mb-2">
    <small className="text-muted d-block">{label}</small>
    <b className={mono ? "text-monospace" : ""}>{isBlank(value) ? defaultValue : value}</b>
  </Col>
);

export const UserAdditionalInfoSection = ({
  platform,
  data,
  convertDateToDisplay,
  getUserType,
  viewType,
}) => {
  if (!data) return null;

  const currentType =
    viewType !== undefined && viewType !== null
      ? Number(viewType)
      : Number(data.type);

  const originLabel = data.origin ? getOriginLabel(data.origin) : null;

  const originNode = data.origin ? (
    <>
      {originLabel || data.origin}
    </>
  ) : null;

  if (platform === 1) {
    const visitDate = formatDateValue({
      formattedValue: data.data_visitacao_formatted,
      rawValue: data.data_visitacao,
      convertDateToDisplay,
    });

    return (
      <div className="mt-3 pt-3 border-top">
        <h6 className="mb-3">Informações Adicionais</h6>
        <Row>
          <InfoField label="ID Externo" value={data.external_user_id || "N/A"} defaultValue="N/A" />
          <InfoField label="Data de Visitação" value={visitDate} />
          <InfoField label="Origem" value={originNode} />
        </Row>
      </div>
    );
  }

  const creationDate = formatDateValue({
    formattedValue: data.creation_date_formatted,
    rawValue: data.creation_date,
    convertDateToDisplay,
  });

  const registerDate = formatDateValue({
    formattedValue: data.register_date_formatted,
    rawValue: data.register_date,
    convertDateToDisplay,
  });

  const lastAccess = formatDateValue({
    formattedValue: data.last_access_formatted,
    rawValue: data.last_access,
    convertDateToDisplay,
  });

  const accessCodeExpires = formatDateValue({
    formattedValue: data.access_code_expires_formatted,
    rawValue: data.access_code_expires,
    convertDateToDisplay,
  });

  const statusValue = !isBlank(data.status_formatted)
    ? data.status_formatted
    : data.status === 0
      ? "Inativo"
      : data.status === 1
        ? "Ativo"
        : "N/A";

  const typeValue = !isBlank(data.type_formatted)
    ? data.type_formatted
    : typeof getUserType === "function"
      ? getUserType(data.type)
      : data.type;

  const exhibitorName =
    typeof data.exhibitor_name === "string"
      ? data.exhibitor_name.replace(/\"/g, "")
      : data.exhibitor_name;

  return (
    <div className="mt-3 pt-3 border-top">
      <h6 className="mb-3">Informações Adicionais</h6>
      <Row>
        <InfoField label="ID Externo" value={data.external_user_id || "N/A"} defaultValue="N/A" />
        <InfoField label="Origem de registro" value={originNode} />
        <InfoField label="Status" value={statusValue} defaultValue="N/A" />
        {currentType !== 0 && <InfoField label="Tipo de usuário" value={typeValue} defaultValue="N/A" />}
        {currentType === 2 && <InfoField label="Expositor associado" value={exhibitorName} />}
        {currentType !== 0 && <InfoField label="Total de participantes coletados" value={data.total_users_collected || 0} defaultValue={0} />}
        <InfoField label="Data de criação" value={creationDate} />
        <InfoField label="Data de registro" value={registerDate} defaultValue="N/A" />

        {currentType === 0 && (
          <InfoField
            label="Ranking"
            value={data.rank_position ? `#${data.rank_position}` : null}
          />
        )}

        {currentType === 0 && (
          <InfoField label="Pontuação" value={data.total_value || 0} defaultValue={0} />
        )}

        {currentType === 0 && (
          <InfoField
            label="Expositores coletados"
            value={data.total_exhibitors_collected || 0}
            defaultValue={0}
          />
        )}

        <InfoField label="Código de acesso" value={data.access_code} mono />
        <InfoField label="Último acesso" value={lastAccess} defaultValue="N/A" />
        <InfoField label="Último código de acesso" value={data.access_code_used} defaultValue="N/A" mono />
        <InfoField label="Expiração do código de acesso" value={accessCodeExpires} defaultValue="N/A" />
        <InfoField
          label="Notificação"
          value={
            data.push_subscription === undefined || data.push_subscription === null
              ? null
              : data.push_subscription
                ? "Ativado"
                : "Desativado"
          }
        />
      </Row>
    </div>
  );
};
